import { themeLight as dna } from 'assets/theme';

if (dna.overrides === undefined) {
  dna.overrides = {};
}

if (dna.overrides.MuiBadge === undefined) {
  dna.overrides.MuiBadge = {};
}

if (dna.overrides.MuiSwitch === undefined) {
  dna.overrides.MuiSwitch = {};
}

if (dna.overrides.MuiButtonGroup === undefined) {
  dna.overrides.MuiButtonGroup = {};
}

dna.overrides = {
  ...dna.overrides,
  MuiExpansionPanel: {
    ...dna.overrides.MuiExpansionPanel,
    root: {
      margin: '0px !important',
    },
  },
  MuiExpansionPanelSummary: {
    ...dna.overrides.MuiExpansionPanelSummary,
    root: {
      padding: 0,
    },
    expandIcon: {
      marginRight: dna.spacing(2),
    },
  },
  MuiBadge: {
    ...dna.overrides.MuiBadge,
    root: {
      ...dna.overrides.MuiBadge.root,
      width: 'initial',
      minWidth: 'initial',
      height: 'initial',
    },
  },
  MuiSwitch: {
    ...dna.overrides.MuiSwitch,
    switchBase: {
      ...dna.overrides.MuiSwitch.switchBase,
      color: 'grey',
    },
    thumb: {
      ...dna.overrides.MuiSwitch.thumb,
      boxShadow: undefined,
    },
  },
  MuiButtonGroup: {
    ...dna.overrides.MuiButtonGroup,
    contained: {
      boxShadow: 'none',
    },
  },
  MuiButton: {
    ...dna.overrides.MuiButton,
    root: {
      borderRadius: 24,
      textTransform: 'none',
    },
    contained: {
      color: '#505050',
      backgroundColor: '#F6F6F6',
      boxShadow: 'none !important',
      '&:hover': {
        boxShadow: 'none !important',
      },
      '&:active': {
        boxShadow: 'none !important',
      },
    },
  },
  MuiCardActions: {
    ...dna.overrides.MuiCardActions,
    root: {
      padding: dna.spacing(2),
    },
  },
  MuiCardHeader: {
    ...dna.overrides.MuiCardHeader,
    root: {
      paddingLeft: dna.spacing(3),
      paddingRight: dna.spacing(3),
    },
  },
  MuiCardContent: {
    ...dna.overrides.MuiCardContent,
    root: {
      padding: dna.spacing(4),
      '&:last-child': {
        paddingBottom: dna.spacing(4),
      },
    },
  },
  MuiInputLabel: {
    ...dna.overrides.MuiInputLabel,
    root: {
      color: dna.palette.grey[500],
    },
    disabled: {
      color: dna.palette.grey[500],
    },
    shrink: {
      fontSize: 16,
      color: dna.palette.text.hint,
    },
  },
};

const stylesAlertBorders = {
  border: `solid 1px ${dna.palette.divider}`,
  borderLeft: 'solid 2px',
  backgroundColor: 'transparent',
};

// lab
(dna.overrides as any).MuiAlert = {
  root: {
    alignItems: 'center',
    marginTop: dna.spacing(1),
    marginBottom: dna.spacing(1),
    padding: dna.spacing(2),
    borderRadius: 0,
    width: '100%',
  },
  message: {
    width: '100%',
    color: dna.palette.text.secondary,
  },
  standardInfo: {
    ...stylesAlertBorders,
    borderLeftColor: dna.palette.grey[300],
  },
  standardSuccess: {
    ...stylesAlertBorders,
    borderLeftColor: dna.palette.success.main,
  },
  standardWarning: {
    ...stylesAlertBorders,
    borderLeftColor: dna.palette.warning.main,
  },
  standardError: {
    ...stylesAlertBorders,
    borderLeftColor: dna.palette.error.main,
  },
};

export const theme = dna;
